import React from 'react'
import { IndexRoute, Route, } from 'react-router'
import filters from 'filters'
import firebase from 'firebase'
import store from 'store'

const requireAuth = (nextState, replace) => {
  if (!firebase.auth().currentUser) {
    let hasLocalStorageUser = filters.localUser()
    if (!hasLocalStorageUser) {
      console.log('Attempting to access a secure route. Please authenticate first.')
      let previousRoute = nextState.location.pathname.substring(1)
      if (previousRoute.charAt(previousRoute.length - 1) === '/') {
        previousRoute = previousRoute.substring(0, previousRoute.length - 1)
      }
      replace({
        pathname: '/',
        state: {
          nextPathname: previousRoute + nextState.location.search
        },
      })
    }
  }
}

const requirePurchase = (packName) => {
  return (nextState, replace) => {
    if (!store.getState().currentGamerPurchaseProfile[packName]) {
      console.log('Attempting to access a secured route. Please purchase the appropriate pack first.')
      let previousRoute = nextState.location.pathname.substring(1)
      if (previousRoute.charAt(previousRoute.length - 1) === '/') {
        previousRoute = previousRoute.substring(0, previousRoute.length - 1)
      }

      replace({
        pathname: '/shop',
        state: { nextPathname: previousRoute, },
      })
    }
  }
}

const Routes = (
  <Route
    getComponent={(location, callback) => {
      require.ensure([], require => {
        let AppWrapper = require('./userInterface/global/AppWrapper.js').default
        callback(null, AppWrapper)
      }, 'AppWrapper')
    }}
    path="/"
  >
    <IndexRoute
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let LandingView = require('./views/authentication/LandingView.js').default
          callback(null, LandingView)
        }, 'LandingView')
      }}
    />
    <Route
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let ArticlesView = require('./views/articles/ArticlesView.js').default
          callback(null, ArticlesView)
        }, 'ArticlesView')
      }}
      onEnter={requireAuth}
      path="/articles"
    />
    <Route
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let CounterStrikeGlobalOffensiveView = require(
            './views/simulator/CounterStrikeGlobalOffensive/CounterStrikeGlobalOffensiveView.js'
          ).default
          callback(null, CounterStrikeGlobalOffensiveView)
        }, 'CounterStrikeGlobalOffensiveView')
      }}
      onEnter={requirePurchase('counterStrikeGlobalOffensivePacks')}
      path="/counter-strike-global-offensive"
    />
    <Route
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let CustomGamesView = require('./views/simulator/bootcamp/CustomGamesView.js').default
          callback(null, CustomGamesView)
        }, 'CustomGamesView')
      }}
      onEnter={requireAuth}
      path="/custom-games"
    />
    <Route
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let DashboardView = require('./views/gamers/DashboardView.js').default
          callback(null, DashboardView)
        }, 'DashboardView')
      }}
      onEnter={requireAuth}
      path="/dashboard"
    />
    <Route
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let FAQView = require('./views/articles/FAQView.js').default
          callback(null, FAQView)
        }, 'FAQView')
      }}
      path="/faq"
    />
    <Route
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let ComingSoonView = require('./views/shared/ComingSoonView.js').default
          callback(null, ComingSoonView)
        }, 'ComingSoonView')
      }}
      onEnter={requireAuth}
      path="/feature-request"
    />
    <Route
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let FlickView = require('./views/simulator/bootcamp/FlickView.js').default
          callback(null, FlickView)
        }, 'FlickView')
      }}
      onEnter={requireAuth}
      path="/flick"
    />
    <Route
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let FollowThroughView = require('./views/simulator/bootcamp/FollowThroughView.js').default
          callback(null, FollowThroughView)
        }, 'FollowThroughView')
      }}
      onEnter={requireAuth}
      path="/follow-through"
    />
    <Route
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let EliteGamerShowdownView = require('./views/simulator/competitions/EliteGamerShowdownView.js').default
          callback(null, EliteGamerShowdownView)
        }, 'EliteGamerShowdownView')
      }}
      onEnter={requireAuth}
      path="/elite-gamer-showdown"
    />
    <Route
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let FlickView = require('./views/simulator/immersive/first-person/FlickView.js').default
          callback(null, FlickView)
        }, 'FlickView')
      }}
      onEnter={requireAuth}
      path="/immersive/first-person/flick"
    />
    <Route
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let FortniteView = require('./views/simulator/immersive/third-person/FortniteView.js').default
          callback(null, FortniteView)
        }, 'FortniteView')
      }}
      onEnter={requirePurchase('fortnitePacks')}
      path="/immersive/fortnite"
    />
    <Route
      path="/leaderboard"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let LeaderboardView = require('./views/leaderboards/LeaderboardView.js').default
          callback(null, LeaderboardView)
        }, 'LeaderboardView')
      }}
    />
    <Route
      path="/leaderboards/flick"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let FlickLeaderboardView = require('./views/leaderboards/FlickLeaderboardView.js').default
          callback(null, FlickLeaderboardView)
        }, 'FlickLeaderboardView')
      }}
    />
    <Route
      path="/leaderboards/follow-through"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let FollowThroughLeaderboardView = require('./views/leaderboards/FollowThroughLeaderboardView.js').default
          callback(null, FollowThroughLeaderboardView)
        }, 'FollowThroughLeaderboardView')
      }}
    />
    <Route
      path="/leaderboards/fortnite"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let FortniteLeaderboardView = require('./views/leaderboards/FortniteLeaderboardView.js').default
          callback(null, FortniteLeaderboardView)
        }, 'FortniteLeaderboardView')
      }}
    />
    <Route
      path="/leaderboards/elite-gamer-showdown"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let DesktopPowerRankingView = require('./views/leaderboards/DesktopPowerRankingView.js').default
          callback(null, DesktopPowerRankingView)
        }, 'DesktopPowerRankingView')
      }}
    />
    <Route
      path="/leaderboards/elite-gamer-showdown-mobile"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let MobilePowerRankingView = require('./views/leaderboards/MobilePowerRankingView.js').default
          callback(null, MobilePowerRankingView)
        }, 'MobilePowerRankingView')
      }}
    />
    <Route
      path="/leaderboards/speed"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let SpeedLeaderboardView = require('./views/leaderboards/SpeedLeaderboardView.js').default
          callback(null, SpeedLeaderboardView)
        }, 'SpeedLeaderboardView')
      }}
    />
    <Route
      path="/leaderboards/tracking"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let TrackingLeaderboardView = require('./views/leaderboards/TrackingLeaderboardView.js').default
          callback(null, TrackingLeaderboardView)
        }, 'TrackingLeaderboardView')
      }}
    />
    <Route
      path="/learning"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let LearningView = require('./views/simulator/bootcamp/LearningView.js').default
          callback(null, LearningView)
        }, 'LearningView')
      }}
      onEnter={requireAuth}
    />
    <Route
      path="/mini-games"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let MiniGamesView = require('./views/simulator/MiniGamesView.js').default
          callback(null, MiniGamesView)
        }, 'MiniGamesView')
      }}
      onEnter={requireAuth}
    />
    <Route
      path="/net-train"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let NetTrainView = require('./views/simulator/bootcamp/NetTrainView.js').default
          callback(null, NetTrainView)
        }, 'NetTrainView')
      }}
      onEnter={requireAuth}
    />
    <Route
      path="/privacy-policy"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let PrivacyPolicyView = require('./views/legal/PrivacyPolicyView.js').default
          callback(null, PrivacyPolicyView)
        }, 'PrivacyPolicyView')
      }}
    />
    <Route
      path="/profile"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let ProfileView = require('./views/gamers/ProfileView.js').default
          callback(null, ProfileView)
        }, 'ProfileView')
      }}
      onEnter={requireAuth}
    />
    <Route
      path="/reset"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let ResetView = require('./views/authentication/ResetView.js').default
          callback(null, ResetView)
        }, 'ResetView')
      }}
    />
    <Route
      path="/settings"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let AccountSettingsView = require('./views/gamers/AccountSettingsView.js').default
          callback(null, AccountSettingsView)
        }, 'AccountSettingsView')
      }}
      onEnter={requireAuth}
    />
    <Route
      path="/shop"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let ShopView = require('./views/shop/ShopView.js').default
          callback(null, ShopView)
        }, 'ShopView')
      }}
      onEnter={requireAuth}
    />
    <Route
      path="/sign-in"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let SignInView = require('./views/authentication/SignInView.js').default
          callback(null, SignInView)
        }, 'SignInView')
      }}
    />
    <Route
      path="/sign-out"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let SignOutView = require('./views/authentication/SignOutView.js').default
          callback(null, SignOutView)
        }, 'SignOutView')
      }}
    />
    <Route
      path="/speed"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let SpeedView = require('./views/simulator/bootcamp/SpeedView.js').default
          callback(null, SpeedView)
        }, 'SpeedView')
      }}
      onEnter={requireAuth}
    />
    <Route
      path="/support"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let SupportView = require('./views/authentication/SupportView.js').default
          callback(null, SupportView)
        }, 'SupportView')
      }}
    />
    <Route
      path="/terms-of-service"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let TermsOfServiceView = require('./views/legal/TermsOfServiceView.js').default
          callback(null, TermsOfServiceView)
        }, 'TermsOfServiceView')
      }}
    />
    <Route
      path="/tracking"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let TrackingView = require('./views/simulator/bootcamp/TrackingView.js').default
          callback(null, TrackingView)
        }, 'TrackingView')
      }}
      onEnter={requireAuth}
    />
    <Route
      path="/verification"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let VerificationView = require('./views/authentication/VerificationView.js').default
          callback(null, VerificationView)
        }, 'VerificationView')
      }}
      onEnter={requireAuth}
    />
    <Route
      path="*"
      getComponent={(location, callback) => {
        require.ensure([], require => {
          let DashboardView = require('./views/gamers/DashboardView.js').default
          callback(null, DashboardView)
        }, 'DashboardView')
      }}
    />
  </Route>
)

export default Routes



// WEBPACK FOOTER //
// ./src/app/Routes.js